import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import dayjs from 'dayjs';

import EnrichIcon from '@/components/Icons/icons/EnrichIcon';

import RightArrow from '../../Icons/icons/RightArrow';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function EnrichCompletedNotification({ notification, handleNavigateList }) {
  return (
    <div className={`single-notification cursor-pointer ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <EnrichIcon height={36} width={36} />
      </div>
      <div className="text-div" style={{ paddingLeft: 8 }}>
        <p className="description" style={{ fontSize: 14, color: 'var(--black)' }}>
          {notification?.title}
        </p>
        <p className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: '0px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={handleNavigateList}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            Check it Out
          </ButtonComponent>
        </p>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
